import React, { useRef, useEffect } from 'react';

import { TextField, FormControl, FormHelperText } from '@material-ui/core';
import { useField } from '@unform/core';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';

import { t, canURL } from '~/helpers';

function Input({
  name,
  label,
  getValue,
  serialize,
  disabled,
  isGrid,
  initialValue,
  ...rest
}) {
  const inputRef = useRef(null);
  const permission = isEqual(canURL(), { read: true });

  const {
    fieldName,
    defaultValue,
    registerField,
    error,
    clearError,
  } = useField(name);
  const selectedDefaultValue =
    initialValue === null ? defaultValue : initialValue;

  function handleChangeValue(event) {
    const { value } = event.target;

    inputRef.current.value = serialize(value);

    getValue(serialize(value));
  }

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [registerField, fieldName]);

  useEffect(() => {
    inputRef.current.value = selectedDefaultValue;
    if (selectedDefaultValue !== undefined && selectedDefaultValue !== null) {
      getValue(serialize(selectedDefaultValue));
    }
  }, [selectedDefaultValue]);

  useEffect(() => {
    if (disabled) clearError();
  }, [disabled]);

  return (
    <FormControl style={{ width: '100%' }}>
      <TextField
        ref={inputRef}
        onChange={handleChangeValue}
        error={!!error}
        defaultValue={t(selectedDefaultValue)}
        label={label}
        variant="outlined"
        fullWidth
        id={name}
        size="small"
        InputLabelProps={{
          shrink: true,
        }}
        {...rest}
        disabled={(permission || disabled) && !isGrid}
        onFocus={clearError}
      />
      {error && <FormHelperText error>{error}</FormHelperText>}
    </FormControl>
  );
}

Input.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  getValue: PropTypes.func,
  serialize: PropTypes.func,
  disabled: PropTypes.bool,
  isGrid: PropTypes.bool,
  initialValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

Input.defaultProps = {
  getValue: () => {},
  serialize: (value) => value,
  disabled: false,
  isGrid: false,
  initialValue: null,
};

export default Input;
